export const MANUSCRIPT_STAGING_TOOL_NAMES = [
  "propose_manuscript_change",
  "stage_manuscript_change",
] as const;

export function isManuscriptStagingToolName(toolName: string | undefined | null): boolean {
  const name = String(toolName ?? "").toLowerCase();
  return MANUSCRIPT_STAGING_TOOL_NAMES.some((candidate) => candidate === name);
}

/** Write mode shows a short "Editing" row; chat-only mode omits the thinking row. */
export function manuscriptStagingThinkingTitleForMode(
  mode: "chat" | "write" | undefined | null,
): string | null {
  if (mode === "chat") return null;
  return "Editing";
}

export function shouldShowManuscriptStagingThinkingTask(
  mode: "chat" | "write" | undefined | null,
): boolean {
  return manuscriptStagingThinkingTitleForMode(mode) != null;
}
